import React from 'react';
import '../styles/main.css';
import { TimelineMax, TweenMax } from 'gsap';

import Workspace from "../containers/Workspace";
import { TransitionGroup } from 'react-transition-group';
import { validateKeydown } from '../helpers/Keymap';
import { fromJS } from 'immutable';
import ErrorHandler from '../helpers/ErrorHandler';
import CommonPopup from '../containers/CommonPopup';
import ConfirmPopup from '../containers/ConfirmPopup';
import ToolTip from '../containers/ToolTip';
import Toast from '../components/Toast';
import io from "socket.io-client"
import { connect } from 'react-redux';
import {IntlProvider, FormattedMessage} from "react-intl";
import axios from 'axios';
import { errorlog } from '../helpers/ErrorLogService';
import { addSceneComplete, updateUserDetails, loadCommonPopup , draggedFile, uploadedFile, updateUserActive, setFullTab, addObjComplete, moveUpdateComplete, duplicateSceneComplete, removeSceneComplete, addSceneTransitionComplete,changeSceneTransColorComplete, changeExpressionComplete, changeActionComplete, changeBgComplete, deleteBgComplete, applyFilterComplete, updateSvgColorComplete, updateSvgThemeComplete, cropImageComplete, flipItemComplete, cropBgComplete, bgColorSelectionComplete, bgGradientColorsComplete, changeSceneDurationComplete, changeTextComplete, groupObjectsComplete, ungroupObjectsComplete, deleteItemComplete, setZIndexComplete, updateTimelineDragChangeComplete, pasteItemsComplete, updateTextComplete, updateGroupTextComplete, pasteScenesComplete ,setSelectedItemsComplete, setSelectedSceneComplete, updateBgColorComplete, updateBgGradientComplete, socketDisconnected, socketConnected, newSocketConnected, changeVideoVolumeComplete, changeAnimationTypeComplete, moveSceneComplete, manageToast, updateBgComplete, updateProjectComplete, updateObjectComplete, addPrebuiltComplete, appLoadProgess, updateSceneComplete, dropBG,applyEnterEffectComplete,applyAllTransitionComplete ,setScenePosition ,setPlayerPosition , addLinkToTextComplete , setWorkspaceItemsOrderComplete ,setAnimateValueComplete, setNewActionComplete,projectRestore,setPropertyWindow,setPaymentPastDue,setWorkspaceTextFocus,addLinkToObjComplete} from '../actions/index';
import config from '../config/app.json';

import { saveScreenshot } from '../helpers/ScreenshotHelper';
import '../styles/deck.css';

let socket;
let actionCount = 0 ; 
let lastVersionSavedTime = new Date();

function getCookie(name) {
    var cookieValue = null;
    if (document.cookie && document.cookie !== '') {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        // Does this cookie string begin with the name we want?
        if (cookie.substring(0, name.length + 1) === (name + '=')) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }
export class App extends React.Component
{

    constructor(props)
    {
        super(props);
        
        this.appUrl = config['APPICONS'][config['APPICONS']['current']];
        this.frameUrl = config['FRAME_ASSET'][config['FRAME_ASSET']['current']];
        this.assetUrl = config['ASSETS'][config['ASSETS']['current']];
        this.apiUrl = config['APIURIS'][config['APIURIS']['current']];
        this.logoutURL = config["APIURIS"][config["APIURIS"]["current"]] + 'logout';
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.state = {
            loaded : false,
            isConnected: true,
            errorThrown:false,
            authError:false,
            sesError: false,
            libraryWidth: 70,
            menuHeight: 60,
            bottomPlayerHeight: 100,
            liteRightWindow : 370,
            liteScenesHeight : 200,
            worksheet: [
                { id: 1, data: "One", color: 'pink' },
                { id: 2, data: "Two", color: '#F0FFFF' },
                { id: 3, data: "Three", color: '#FFE4C4' },
                { id: 4, data: "Four", color: '#6495ED' },
                { id: 5, data: "Five", color: '#008B8B' },
                { id: 6, data: "Six", color: '#00BFFF' },
                { id: 7, data: "Seven", color: '#DAA520' },
                { id: 8, data: "Eight", color: '#F08080' },
                { id: 9, data: "Nine", color: '#778899' },
                { id: 10, data: "Ten", color: '#9370DB' },
                { id: 11, data: "Eleven", color: '#FFDEAD' },
                { id: 12, data: "Twelve", color: '#FFDAB9' },
                { id: 13, data: "Thirteen", color: '#A0522D' },
                { id: 14, data: "Fourteen", color: '#FF6347' },
                { id: 15, data: "Fifteen", color: '#9ACD32' },
            ],
            appLangData : {},
            sceenPosition: 1,
            screenPressed: false,
            selectedItems: fromJS(["alwqde1534929278802"]),
            playerControl: "", workspace: "", slides: "", menuBar: "", library: "", textProperty: "",
            setAnimaker : false,
            toolTipData : {}
        };
        this.changeBoxes = this.changeBoxes.bind(this);
        this.appLoadingCompleted = this.appLoadingCompleted.bind(this);
        this.socketId = "";
        this.maxCount = config["VERSION"]["maxCount"];
        this.maxSeconds = config["VERSION"]["maxSeconds"]; 

        if(this.props.mode === 'slide'){
            socket = io.connect(config["SOCKETURIS"][config["SOCKETURIS"]["current"]], {transports: ['websocket'], query: "pr="+this.props.projectid+"&mode=1"})
        }
        else{
            socket = io.connect(config["SOCKETURIS"][config["SOCKETURIS"]["current"]], {transports: ['websocket'], query: "pr="+this.props.projectid})
        }

        socket.on('connect', () =>
        {
            if (!this.state.isConnected)
                this.setState({ isConnected: true })

            socket.on('disconnect', (reason) =>
            {
                if (reason === 'io server disconnect')
                {
                    // the disconnection was initiated by the server, you need to reconnect manually
                    socket.connect();
                }
                if(this.state.isConnected)
                this.setState({ isConnected: false })

                // else the socket will automatically try to reconnect
            });

        });

        socket.on('disconnect', (reason) =>{
            if (reason === 'io server disconnect')
                {
                    // the disconnection is initiated by the server, you need to reconnect manually
                    socket.disconnect();
                    this.setState({ authError: true })
                }
                this.setState({ isConnected: false })
        })
        
        socket.on('authenticated',()=>{
            if(this.props.mode!=='slide'){
                socket.emit('adduser', this.props.userId, null, this.props.projectUsrImg, this.props.projectUsr);
                }
                this.props.loadProject(this.props.projectid, this.props.projectUsr,this.props.mode,this.props.userId,this.props.projectUsrImg,socket.id);
                this.props.loadUserFonts(this.props.projectid, this.props.userId, socket.id);
                this.props.setUserDetails({userId : this.props.userId, projectId : this.props.projectid, teamId : this.props.teamId})
                this.props.loadSceneThumbs({userId : this.props.userId, projectId : this.props.projectid});
        })


        socket.on('connect_error', (error) =>
        {
            // ...
            // console.log("connection error");
            

        });

        socket.on('connect_timeout', (timeout) =>
        {
            // console.log("connection timeout");
            this.setState({ isConnected: false })

            // ...
        });

        // socket.on('error', (error) =>
        // {
        //     // ...
        //     // console.log("connection error");
        //     if(error === 'authentication error'){
        //         socket.disconnect();
        //         this.setState({ authError: true })   
        //     }
        //     else if(error === 'Internal server error'){
        //         socket.disconnect();
        //         this.setState({ errorThrown: true }) 
        //     }
        //     else{
        //     this.setState({ isConnected: false })
        //     }

        // });

        socket.on('unauthorised', (reason, socketId) => {
            if (reason === 'authentication error') {
                socket.disconnect();
                this.setState({ authError: true })
            }
            else if (reason === 'Internal server error') {
                socket.disconnect();
                this.setState({ errorThrown: true })
            } else {
                this.setState({ isConnected: false })
            }
        });

        socket.on('reconnect', (attemptNumber) =>
        {
            // ...
            // console.log("reconnect", attemptNumber);
            this.setState({ isConnected: false })
        });

        socket.on('reconnect_attempt', (attemptNumber) =>
        {
            // console.log("reconnect attempt", attemptNumber);
            this.setState({ isConnected: false })

            // ...
        });

        socket.on('reconnecting', (attemptNumber) =>
        {
            // console.log("reconnecting", attemptNumber);
            this.setState({ isConnected: false })

            // ...
        });

        socket.on('reconnect_error', (error) =>
        {
            // ...
            // console.log("reconnect_error", error);
            this.setState({ isConnected: false })


        });


        socket.on('reconnect_failed', () =>
        {
            // ...
            // console.log("reconnect_failed");
            this.setState({ isConnected: false })

        });
        var timeout;
        this.processingTimeOut = (socketId) =>{
            timeout  = setTimeout(()=>{
                if(!this.props.isNewAction)
                    socket.emit('saveme',this.props.projectId,socketId);
            },2000)
        }


        socket.on ('createversionComplete',(userName,socketid)=>{
          if(this.props.propertyWindow.get('isOpened') && this.props.propertyWindow.get('component')==='history'){
            const {projectid, userId, teamId} = this.props;
            let date = new Date();
           let timeZone = (-date.getTimezoneOffset() < 0 ? '-' : '+') + (Math.abs(date.getTimezoneOffset() / 60) < 10 ? '0' : '') + (Math.floor(Math.abs(date.getTimezoneOffset() / 60))) + ':'+(Math.abs(date.getTimezoneOffset() % 60)<10?'0':'')+(Math.abs(date.getTimezoneOffset() % 60)) ; 
            let url = this.apiUrl + 'deck/v/gav';
            const params = new URLSearchParams();
            params.append("projectid", projectid);
            params.append("userid", userId);
            params.append("teamid", teamId);
            // params.append("from",0);
            // params.append("size",20)
            params.append("tz",timeZone)
            axios({
                method: 'post',
                url: url,
                headers: {"Content-Type": "application/x-www-form-urlencoded",  "X-CSRFToken": getCookie("csrftoken"), "Authorization" : getCookie("encoded_token") },
                data: params
            }).then(function (response) {
                if(response.status === 200 && Object.keys(response.data).length !==0 ){
                    this.props.addVersionHistory(response.data);
                }
                
            }.bind(this)).catch(function (error) {
                if(error.response.status !== 422){
            this.props.manageToast({action : "add", type : "error", "message" : "common.toast.msg", subMessage : "common.toast.submsg", formatId: "both"});
            }
            }.bind(this));
        }

        })
        
        socket.on('restoreChecking',(userName,socketid)=>{
            if(socketid === socket.id){
                socket.emit('restoreCheck',userName)
            }
            else{
                this.setState({isRestoring:true,restoreUser:userName})

            }
        })

        socket.on('restoreStartComplete',(userName,socketid)=>{
            if(socketid === socket.id){
                const {projectid, userId, teamId,versionId} = this.props;
                let url = this.apiUrl + 'deck/v/rsv/';
                const params = new URLSearchParams();
                params.append("projectid", projectid);
                params.append("userid", userId);
                params.append("teamid", teamId);
                params.append("versionid", versionId);
                axios({
                    method: 'post',
                    url: url,
                    headers: {"Content-Type": "application/x-www-form-urlencoded",  "X-CSRFToken": getCookie("csrftoken"), "Authorization" : getCookie("encoded_token") },
                    data: params
                }).then(function (response) {
                    if(response.status === 200){  
                        // this.removeConflictData(response.data.project.scenes);
                        // console.log(response.data)
                        // this.props.initiateProject(response.data);
                        // this.props.appLoadProgess(20); 
                        // this.props.projectRestore({versionId:null,isRestore:false,isEmit:false},socket); 
                        // this.props.setPropertyWindow({'component' : ''});
                        socket.emit('restored',userName); 
                        // actionCount=0;
                        // let dateNow = new Date();
                        // lastVersionSavedTime = dateNow;
                        window.location.reload();
                         
                    }
                    
                }.bind(this)).catch(function (error) {
                    if(error.response.status === 422){
                        this.props.manageToast({action : "add", type : "error", "message" :error.response.message , formatId: "msg"});
                    }
                    else if (error.response.status === 401){
                        this.props.manageToast({action : "add", type : "error", "message" : error.response.message, formatId: "msg"});
                    }
                    else{
                        this.props.manageToast({action : "add", type : "error", "message" : "common.toast.msg", subMessage : "common.toast.submsg", formatId: "both"});
                    }
                }.bind(this));
            }
            else{
                this.setState({isRestoring:true,restoreUser:userName})
            }
        })

        socket.on('restoredComplete',(userName,socketid)=>{
            this.props.projectRestore({versionId:null,isRestore:false,isEmit:false},socket);
            this.setState({isRestoring:false,isRestored:true,restoreCheck:false})
            if(socket.id === socketid){
                this.setState({restoreUser:null})
                setTimeout(()=>{
                    this.setState({isRestored:false})
                }, 1500);
                
            }
            else{
                this.setState({restoreUser:userName})
            }
        })
        socket.on('restoring',(socketid)=>{
            if(socket.id === socketid) this.setState({restoreCheck:true});
        })
        socket.on('processing',(socketId)=>{
            this.props.setNewActionComplete(false)
            clearTimeout(timeout);
            this.processingTimeOut(socketId);
        });
        
        this.checkVersion=()=>{
            let currentDate = new Date();
            let diffSeconds = (currentDate-lastVersionSavedTime)/1000;
            if(diffSeconds > this.maxSeconds){
                socket.emit("createversion", 1,this.props.userId)
                actionCount = 0 ;
                lastVersionSavedTime = currentDate;
            }
            else{
                if(actionCount > this.maxCount){
                    socket.emit("createversion", 2,this.props.userId);
                    actionCount = 0 ;
                    lastVersionSavedTime = currentDate;
                }
            }
        }

        socket.on('addSceneComplete', (slideIndex, newslide, socketId) =>
        {
            if(socketId !== socket.id) this.props.addSceneComplete(slideIndex, newslide, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
            
        })

        socket.on('projectSaveException', (data, slideIndex, newslide, socketId) =>
        {
            errorlog(data, {slideIndex, newslide}, "Server-projectSaveException");
            this.setState({ errorThrown: true })
        })

        socket.on('duplicateSceneComplete', (slideIndex, newslide, socketId) =>
        {
            
            if(socketId !== socket.id) this.props.duplicateSceneComplete(slideIndex, newslide, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on('addObjectComplete', (selectedScene, workspaceIds, workspaceData, workspaceChildrenIds, workspaceChildData, socketId) =>
        {
            if(socketId !== socket.id) this.props.addObjComplete(selectedScene, workspaceIds, workspaceData, workspaceChildrenIds, workspaceChildData, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on('moveUpdateComplete', (selectedScene, workspaceItems, workspaceChildren, currentContainer,socketId) =>
        {
            if(socketId !== socket.id) this.props.moveUpdateComplete(selectedScene, workspaceItems, workspaceChildren, currentContainer,socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on('removeSceneComplete', (slideIndex, socketId) =>
        {
            if(socketId !== socket.id) this.props.removeSceneComplete(slideIndex, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on('addSceneTransitionComplete', (slideIndex, transitionName, sizes, socketId) =>
        {         
            if(socketId !== socket.id) this.props.addSceneTransitionComplete(slideIndex, transitionName, sizes, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        }) 
        socket.on('changeSceneTransColorComplete', (selectedScene, color, socketId) =>
        {
            if(socketId !== socket.id) this.props.changeSceneTransColorComplete(selectedScene, color, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })  
        

        socket.on('changeExpressionComplete', (selectedIndex, itemId, itemLabel, socketId) =>
        {
            if(socketId !== socket.id) this.props.changeExpressionComplete(selectedIndex, itemId, itemLabel, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on('changeActionComplete', (selectedIndex, itemId, itemLabel, socketId) =>
        {
            if(socketId !== socket.id) this.props.changeActionComplete(selectedIndex, itemId, itemLabel, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on('changeBgComplete', (selectedScene, workspaceBG, deleteId, deleteData, socketId) =>
        {
            if(socketId !== socket.id) this.props.changeBgComplete(selectedScene, workspaceBG, deleteId, deleteData, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on('deleteBgComplete', (selectedScene, socketId) =>
        {
            if(socketId !== socket.id) this.props.deleteBgComplete(selectedScene, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on('changeVideoVolumeComplete', (selectedScene, objectId, socketId) =>
        {
            if(socketId !== socket.id) this.props.changeVideoVolumeComplete(selectedScene, objectId, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on('applyFilterComplete', (selectedScene, objectId, objectData, socketId) =>
        {
           
            if(socketId !== socket.id) this.props.applyFilterComplete(selectedScene, objectId, objectData, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }

        })

        socket.on('updateSvgColorComplete', (selectedScene, container, itemId, itemCls, colorData, socketId) =>
        {
            if(socketId !== socket.id) this.props.updateSvgColorComplete(selectedScene, container, itemId, itemCls, colorData, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on('updateSvgThemeComplete', (projectid, selectedScene, container, itemId, colorData, isBG, socketId) =>
        {
           
            if(socketId !== socket.id) this.props.updateSvgThemeComplete(projectid, selectedScene, container, itemId, colorData, isBG, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on('cropImageComplete', (selectedScene, itemId, objectData, socketId) =>
        {
            if(socketId !== socket.id) this.props.cropImageComplete(selectedScene, itemId, objectData, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on('flipItemComplete', (selectedScene, itemId, flipPosition, socketId) =>
        {
            if(socketId !== socket.id) this.props.flipItemComplete(selectedScene, itemId, flipPosition, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on('cropBgComplete', (selectedScene, objectData, isVideo, videoId, bgScales, socketId) =>
        {
            if(socketId !== socket.id) this.props.cropBgComplete(selectedScene, objectData, isVideo, videoId, bgScales, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on('bgColorSelectionComplete', (selectedScene, objectData, socketId) =>
        {
            if(socketId !== socket.id) this.props.bgColorSelectionComplete(selectedScene, objectData, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on('bgGradientColorsComplete', (selectedScene, radialStatus, direction, radius, socketId) =>
        {
            if(socketId !== socket.id) this.props.bgGradientColorsComplete(selectedScene, radialStatus, direction, radius, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on('changeTextComplete', (selectedScene, currentContainer, itemId, objectData, socketId) =>
        {
            
            var selfUpdate = socketId !==  socket.id;
            
            if(socketId !== socket.id) this.props.changeTextComplete(selectedScene, currentContainer, itemId, objectData, socketId, socket.id, selfUpdate)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })


        socket.on('groupObjectsComplete', (selectedScene, removeIds, workspaceItems, workspaceChildren,workspaceItemsOrder, socketId) =>
        {
           
            if(socketId !== socket.id) this.props.groupObjectsComplete(selectedScene, removeIds, workspaceItems, workspaceChildren,workspaceItemsOrder, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
                
        })

        socket.on('ungroupObjectsComplete', (selectedScene, removeIds, workspaceChildren,workspaceItemsOrder ,socketId) =>
        {
            if(socketId !== socket.id) this.props.ungroupObjectsComplete(selectedScene, removeIds, workspaceChildren,workspaceItemsOrder, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on('deleteItemComplete', (selectedScene, workspaceIds, workspaceChildrenIds, indexChangeIds,socketId) =>
        {
            if(socketId !== socket.id) this.props.deleteItemComplete(selectedScene, workspaceIds, workspaceChildrenIds, indexChangeIds, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on('setZIndexComplete', (selectedScene, indexChangeIds, socketId) =>
        {
            if(socketId !== socket.id) this.props.setZIndexComplete(selectedScene, indexChangeIds, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        
        socket.on('updateTimelineDragChangeComplete', (selectedScene, itemData, actionData, idVal, childToUpdate, socketId) =>
        {
            if(socketId !== socket.id) this.props.updateTimelineDragChangeComplete(selectedScene, itemData, actionData, idVal, childToUpdate, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on('pasteItemsComplete', (selectedScene, workspaceIds, workspaceChildrenIds, workspaceData, workspaceChildData, socketId) =>
        {
            if(socketId !== socket.id) this.props.pasteItemsComplete(selectedScene, workspaceIds, workspaceChildrenIds, workspaceData, workspaceChildData, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

       

        socket.on('updateTextComplete', (isGrouped, selectedScene, selectedId, container, formats, childIds, socketId)=>{
            var selfUpdate = socketId !==  socket.id;
            if(socketId !== socket.id) this.props.updateTextComplete(isGrouped, selectedScene, selectedId, container, formats, childIds, socketId, socket.id, selfUpdate)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on('updateGroupTextComplete',(selectedScene, workspaceItems, workspaceChildren, socketId)=>{
            var selfUpdate = socketId !==  socket.id;
            if(socketId !== socket.id)  this.props.updateGroupTextComplete(selectedScene, workspaceItems, workspaceChildren, socketId, socket.id, selfUpdate)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on("pasteScenesComplete",(selectedScene, scenes, socketId)=>{
            if(socketId !== socket.id) this.props.pasteScenesComplete(selectedScene, scenes, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on("setSelectedItemsComplete",(projectid, selectedItems, projectUsr, userId,projectUsrImg,socketid)=>{
            this.props.setSelectedItemsComplete(projectid, selectedItems, projectUsr, userId,projectUsrImg,socketid, socket.id)
        })
        
        socket.on("setSelectedSceneComplete",(projectid, selectedItems, projectUsr, userId,projectUsrImg,socketid)=>{
          
            this.props.setSelectedSceneComplete(projectid, selectedItems, projectUsr, userId,projectUsrImg,socketid, socket.id)
        })

        socket.on("updateBgColorComplete",(selectedScene,Cls, color, socketId)=>{
            if(socketId !== socket.id) this.props.updateBgColorComplete(selectedScene, Cls, color, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on("updateBgGradientComplete",(selectedScene, gradientIndex, gradientSecIndex, color, socketId)=>{
            if(socketId !== socket.id) this.props.updateBgGradientComplete(selectedScene, gradientIndex, gradientSecIndex, color, socketId, socket.id)
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on("connectionComplete",(projectId, userId, selectedItems,imageUrl,projectUsr,socketId)=>{
            this.props.socketConnected(projectId, userId, selectedItems, imageUrl, projectUsr, socketId, socket.id);
         
            socket.emit('sendData', {userId : this.props.userId, selectedItems : this.props.selectedItems, selectedScene : this.props.selectedScene, imageUrl : this.props.projectUsrImg, userName : this.props.projectUsr, socketId : socket.id} );
        })

        socket.on("changeAnimationTypeComplete",(selectedScene, itemId, value, socketId)=>{
            if(socketId !== socket.id) this.props.changeAnimationTypeComplete(selectedScene, itemId, value, socketId, socket.id);
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on("moveSceneComplete",(projectid, newIndex, oldIndex, socketId)=>{
           
            if(socketId !== socket.id) this.props.moveSceneComplete(projectid, newIndex, oldIndex, socketId, socket.id);
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on("updateSceneValueComplete",(projectid, selectedScene, toUpdate, toEmit,socketId)=>{
           
            if(socketId !== socket.id) this.props.updateSceneComplete(projectid, selectedScene, toUpdate, toEmit, socketId, socket.id);
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on("updateBgComplete",(projectid, selectedScene, toUpdate, socketId)=>{
            if(socketId !== socket.id) this.props.updateBgComplete(projectid, selectedScene, toUpdate, socketId, socket.id);
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on("updateProjectComplete",(projectid, toUpdate, socketId)=>{
           
            if(socketId !== socket.id) this.props.updateProjectComplete(projectid, toUpdate, socketId, socket.id);
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on("updateObjectComplete",(projectid, selectedScene, selectedItem, container, toUpdate, socketId)=>{
           
            if(socketId !== socket.id) this.props.updateObjectComplete(projectid, selectedScene, selectedItem, container, toUpdate, socketId, socket.id);
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on("addPrebuiltComplete",(selectedScene, prebuiltData, replace, addAll, socketId)=>{
            if(socketId !== socket.id) this.props.addPrebuiltComplete(selectedScene, prebuiltData, replace, addAll, socketId, socket.id);
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on("disconnectComplete",(socketId)=>{
            this.props.socketDisconnected(socketId)
        })

        socket.on("sendDataComplete", (data, socketId)=>{
            if(socketId !== socket.id) this.props.newSocketConnected(data);
        })

        socket.on("applyEnterEffectComplete",(projectid,selectedScene,effectData,isUndo,sceneEffectData,socketId)=>{
           
            if(socketId !== socket.id) this.props.applyEnterEffectComplete(projectid,selectedScene,effectData,isUndo,sceneEffectData,socketId, socket.id);
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on("applyAllTransitionComplete",(projectid, transData,isUndo, seceneTransData,socketId)=>{
           
            if(socketId !== socket.id) this.props.applyAllTransitionComplete(projectid, transData,isUndo, seceneTransData, socketId, socket.id);
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on("addLinkToTextComplete",(projectid, selectedScene, container,selectedItem, hyperLinkData, socketId)=>{
           
            if(socketId !== socket.id) this.props.addLinkToTextComplete(projectid, selectedScene, container,selectedItem, hyperLinkData, socketId,socket.id);
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on("addLinkToObjComplete",(projectid, selectedScene,selectedItem,linkData, socketId)=>{
           
            if(socketId !== socket.id) this.props.addLinkToObjComplete(projectid, selectedScene,selectedItem,linkData, socketId,socket.id);
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })

        socket.on("onWorkspaceItemsOrderComplete",(projectId,selectedScene,container,workspaceItemsOrder,socketId)=>{
            if(socketId !== socket.id) this.props.setWorkspaceItemsOrderComplete(projectId,selectedScene,container,workspaceItemsOrder, socketId,socket.id);
            else{
                actionCount++;  
                this.checkVersion();    
            }
            
        })

        socket.on("onSetAnimateValueComplete",(projectid,selectedScene,container,selectedItem,animateData,socketId)=>{
            if(socketId !== socket.id) 
                this.props.setAnimateValueComplete(projectid,selectedScene,container,selectedItem,animateData,socketId);
            else{
                actionCount++;  
                this.checkVersion();    
            }
        })
        
        socket.on('userSessionClosed', (data) => {
            if (data.user === this.props.userId) {
            socket.disconnect();
            this.setState({ sesError: true })
            }
            })
        
    }

    loadProjectData  = () => {
        try{
            const params = new URLSearchParams(window.location.search);
            return axios({
                method: 'post',
                url: config["APIURIS"][config["APIURIS"]["current"]] + 'getSlidesRenderProjectData/',
                headers: {  "X-CSRFToken": getCookie("csrftoken"), "Authorization" : getCookie("encoded_token") },
                data: params
            })
        }catch(err){
            errorlog("Error in loadProjectData", err, "Server-loadProjectData");

        }
    }

    loadLanguage = () => {
        try{
            const params = new URLSearchParams();
            params.append('l', this.props.langToLoad);
            params.append('u', this.props.userId);
            params.append('from', 'deck');
            return axios({
                method: 'post',
                url: config["APIURIS"][config["APIURIS"]["current"]] + 'deck/glangd/',
                headers: {  "X-CSRFToken": getCookie("csrftoken"), "Authorization" : getCookie("encoded_token") },
                data: params
            })
        }catch(err){
            errorlog('Error in loadLanguage ', err, "Server-loadLanguage");
        }
    }

    async checkIsAssetExist(url,key){
        try {
            const response = await axios.get(url);
            // console.log(url,key);
            return response.status;
        }
        catch (err) {
            console.log(err,key);
            return 403
        }
    }

    async validateSource(project) {
        try {
            let { workspaceHeight, workspaceWidth, scenes } = project;
            console.log('inside validate src')
            for(let sceneNo in scenes) {
                var scene = scenes[sceneNo];
                let { workspaceItems, workspaceChildren, workspaceBG, transEffect } = scene;
    
                await this.validateWsItemsSrc(workspaceItems, workspaceWidth, workspaceHeight);
                await this.validateWsItemsSrc(workspaceChildren, workspaceWidth, workspaceHeight);
    
                const bgTypes = ["BG", "IMG", "UPIMAGE"]
                const { type, subType, src } = workspaceBG;
                var sourceType = workspaceBG.sourceType;
                if (src && bgTypes.includes(type)) {
                    let configBasePath = "", backgroundSource = "";
                    // if (type === 'UPIMAGE' && sourceType.toLowerCase() !== "gif") {
                    //     let typrToSet = 'UPLOADS', uploadfileUrl = "";
                    //     configBasePath = config[typrToSet][config[typrToSet].workspace_UPIMAGE];
                    //     backgroundSource = configBasePath + src;
                    //     if (src.split("/").length == 3) {
                    //         var fileName
                    //         if (sourceType != undefined)
                    //             fileName = src.split("/")[2].split(".")[0] + "." + sourceType;
                    //         else
                    //             fileName = src.split("/")[2].split(".")[0] + ".jpg"
                    //         uploadfileUrl = src.split("/")[0] + "/" + src.split("/")[1] + "/" + fileName
                    //         backgroundSource = configBasePath + uploadfileUrl
                    //     }
                    //     else {
                    //         var fileName
                    //         if (sourceType != undefined)
                    //             fileName = src.split("/")[3].split(".")[0] + "." + sourceType;
                    //         else
                    //             fileName = src.split("/")[3].split(".")[0] + ".jpg";
                    //         uploadfileUrl = src.split("/")[0] + "/" + src.split("/")[1] + "/" + fileName
                    //         backgroundSource = configBasePath + uploadfileUrl
                    //     }
                    // }
                    // else 
                    if (type === "BG") {
                        if(workspaceBG.subType === 'EBG'){
                            configBasePath = this.assetUrl+config['EBG'][config["EBG"].workspace];
                            backgroundSource = configBasePath + workspaceBG.src;
                          }else{
                            configBasePath = this.assetUrl+config[type][config[type].workspace];
                            backgroundSource = configBasePath + workspaceBG.src;
                          }
                    } else if (type === "IMG" && subType !== 'OBGIMG' && subType !== "GIPHY") {
                        configBasePath = this.assetUrl + config["BG"]['obgsrc'];
                        backgroundSource = configBasePath + src.replace("/proxy1", "");
                    }
    
                    const status = await this.checkIsAssetExist(backgroundSource);
                    console.log("The status", status);
                    if (status !== 200) {
                        scene['workspaceBG'].type = "";
                        scene['workspaceBG'].src = "";
                    }
                }
            }
        } catch(e) {
            console.log(e);
        }

    }

    async validateWsItemsSrc(data, workspaceWidth, workspaceHeight) {
        for(let item in data) {
            let wsItem = data[item];
            var configPath = this.assetUrl + config[wsItem.type][config[wsItem.type][(wsItem.subType) ? 'workspace_' + wsItem.subType : 'workspace']];
            let ImgSrc = "";
            if (wsItem.subType === 'EPROP' || wsItem.subType === 'GETTYICON' || wsItem.subType === 'GRAD') {
                configPath = this.assetUrl + config[wsItem.subType][config[wsItem.subType]['workspace']];
            }
            // if (wsItem.type === "UPLOADS" && wsItem.subType === "UPIMAGE" && wsItem.sourceType.toLowerCase() !== "gif") {
            //     configPath = config[wsItem.type][config[wsItem.type][(wsItem.subType) ? 'workspace_' + wsItem.subType : 'workspace']];
            //     let uploadfileUrl = "";

            //     if (wsItem.src.split("/").length == 3) {
            //         var fileName
            //         if (wsItem.sourceType != undefined)
            //             fileName = wsItem.src.split("/")[2].split(".")[0] + "." + wsItem.sourceType;
            //         else
            //             fileName = wsItem.src.split("/")[2].split(".")[0] + ".jpg"

            //         uploadfileUrl = wsItem.src.split("/")[0] + "/" + wsItem.src.split("/")[1] + "/" + fileName
            //         ImgSrc = configPath + uploadfileUrl
            //     }
            //     else {
            //         var fileName

            //         if (wsItem.sourceType != undefined)
            //             fileName = wsItem.src.split("/")[3].split(".")[0] + "." + wsItem.sourceType;
            //         else
            //             fileName = wsItem.src.split("/")[3].split(".")[0] + ".jpg";

            //         uploadfileUrl = wsItem.src.split("/")[0] + "/" + wsItem.src.split("/")[1] + "/" + fileName
            //         ImgSrc = configPath + uploadfileUrl

            //     }
            // }
            // else 
            if (wsItem.subType === 'OBGIMG') {
                // configPath = this.assetUrl + config["BG"]['obgsrc'] + wsItem.src.replace("proxy1/", "");
                // ImgSrc = configPath;
            }
            else if (wsItem.subType === 'ECHR' || wsItem.type === "SCR" || wsItem.subType === "EMOJI" || wsItem.subType === 'ANIMAL') {
                if (wsItem.type === 'SCR') {
                    let projectType = workspaceWidth > workspaceHeight ? "horizontal" : workspaceHeight > workspaceWidth ? "vertical" : "square";
                    configPath = this.assetUrl + config[wsItem.type][config[wsItem.type]['workspace']] + projectType + '/'
                }
                else if (wsItem.subType === 'ECHR')
                    configPath = this.assetUrl + config[wsItem.subType][config[wsItem.subType]['workspace']];
                else if (wsItem.subType === 'ANIMAL') {
                    configPath = this.assetUrl + config["CHR"][config["CHR"]['workspace']];
                }
                else
                    configPath = this.assetUrl + config[wsItem.type][config[wsItem.type]['workspace']];
            }

            let finalPath = ""

            if (wsItem.type === 'PROP' || wsItem.type === "CHR" || wsItem.type === "SCR") {
                finalPath = configPath + wsItem.src;
                if(wsItem.subType === "CHR" || wsItem.subType === "CCHR") {
                    const [src, extension] = wsItem.src.split('.');
                    configPath = this.assetUrl + config[wsItem.subType][config[wsItem.subType]['workspace']];
                    let url = `${src}-${wsItem.expression}.${extension}`;
                    finalPath = configPath + url;
                }
            } else if ((wsItem.type === "UPLOADS" && wsItem.subType === "UPIMAGE" && wsItem.sourceType.toLowerCase() !== "gif") || wsItem.subType === 'OBGIMG') {
                // finalPath = ImgSrc;
                // var srcType = wsItem.sourceType ? wsItem.sourceType : wsItem.src.split(".")[wsItem.src.split(".").length - 1];
                // if (wsItem.type === 'UPLOADS' && srcType.toLowerCase().includes('svg')) {
                //     finalPath = configPath + wsItem.src;
                // }
            } else if(wsItem.type === "FRAME" || wsItem.type === "GRID") {
                configPath = `${this.frameUrl}${[config[wsItem.type].DEFAULT_IMAGE]}`;
                finalPath = `${configPath}`
                // console.log(finalPath)
            }

            if (finalPath !== "") {
                // Validation code goes here
                let status = await this.checkIsAssetExist(finalPath, item);

                if (status !== 200) {
                    delete data[item];
                }
            }
        }
    }


    startApp = () => {
        try{
            const langRes = this.loadLanguage();
            langRes.then((lresp) => {
                this.setState({
                    appLangData : lresp.data
               })
                const resp = this.loadProjectData();
                resp.then(async function (resp) {
                    if (resp.status === 200) {
                        await this.validateSource(resp.data.project);
                        this.removeConflictData(resp.data.project.scenes);
                        this.writeLoaderData(resp.data.project); // Taking the items into an array to check for loading later.
                        this.props.initiateProject(resp.data);
                        this.props.appLoadProgess(20);
                        this.setState({ loaded: true } );
                    }
                    
                }.bind(this), function (error) {
                    errorlog("error in StartApp", error, "server-startApp" );
                })

            }).catch((err) => {
                errorlog('Error in loadLanguage call', err, "server-startApp" );
            })
        }catch(err){
            errorlog('Error in startApp ', err, "server-startApp" );
        }
    }

    removeConflictData(scenes){
        for (let i = 0; i < scenes.length; i++) {
            var ChildrenIds = []
            for (var key in scenes[i].workspaceItems) {
                if (scenes[i].workspaceItems[key].type === "GROUP") {
                    for (var m = 0; m < scenes[i].workspaceItems[key].groupChildren.length; m++) {
                        ChildrenIds.push(scenes[i].workspaceItems[key].groupChildren[m])
                    }
                }
                let wsItem = scenes[i].workspaceItems[key];
                if (wsItem.type === "FRAME") {
                    let clipDetails = wsItem.clipDetails;
                    if (clipDetails) {
                        for (let clipKey in clipDetails) {
                            let imgDetails = clipDetails[clipKey]["imgDetails"];
                            if (imgDetails) {
                                if (imgDetails.src.includes("blob:")) {
                                    delete scenes[i].workspaceItems[key];
                                }
                            }
                        }
                    }
                } else if (wsItem.type === "GRID") {
                    const gridCells = wsItem.gridData && wsItem.gridData.gridCells;
                    if (gridCells) {
                        for (const cell of Object.values(gridCells)) {
                            const imgDetails = cell.imgDetails;
                            if (imgDetails) {
                                if (imgDetails.src && imgDetails.src.includes("blob:")) {
                                    delete scenes[i].workspaceItems[key];
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        
            for (var key in scenes[i].workspaceChildren)
            {
                if(!ChildrenIds.includes(key))
                {
                    delete scenes[i].workspaceChildren[key]
                }
            }
        }
    }

    writeLoaderData(data) {
        var isItemPresent = false;
        var assetArr = [];
        for (let i = 0; i < data.scenes.length; i++) {
            for (var key in data.scenes[i].workspaceItems) {
                let itemType = data.scenes[i].workspaceItems[key].type;
                let itemSourceType = data.scenes[i].workspaceItems[key].sourceType;
                isItemPresent = true;
                if (itemType === "FRAME") {
                    let clipDetails = data.scenes[i].workspaceItems[key].clipDetails;
                    if (clipDetails) {
                        for (let clipKey in clipDetails) {
                            let imgDetails = clipDetails[clipKey]["imgDetails"];
                            itemSourceType = imgDetails["sourceType"];
                            if (imgDetails) {
                                if (imgDetails.subType !== "GIPHY") {
                                    if (!imgDetails.src.includes("blob:")) {
                                        let imageId = `${clipKey}-${key}`;
                                        assetArr.push(imageId)
                                    }
                                }
                            }
                        }
                    }
                } else if (itemType === "GRID") {
                    const item = data.scenes[i].workspaceItems[key];
                    const gridCells = item.gridData && item.gridData.gridCells;
                    if (gridCells) {
                        for (const [cellId, cell] of Object.entries(gridCells)) {
                            const imgDetails = cell.imgDetails;
                            if (imgDetails) {
                                if (imgDetails.subType !== "GIPHY") {
                                    if (!imgDetails.src.includes("blob:")) {
                                        const imageId = `${cellId}-${key}`;
                                        assetArr.push(imageId);
                                    }
                                }
                            }
                        }
                    }
                }
            }
            for (var key in data.scenes[i].workspaceChildren) {
                let itemType = data.scenes[i].workspaceChildren[key].type;
                let itemSourceType = data.scenes[i].workspaceChildren[key].sourceType;
                if (itemType === "FRAME") {
                    let clipDetails = data.scenes[i].workspaceChildren[key].clipDetails;
                    if (clipDetails) {
                        for (let clipKey in clipDetails) {
                            let imgDetails = clipDetails[clipKey]["imgDetails"];
                            itemSourceType = imgDetails["sourceType"]
                            if (imgDetails) {
                                // let isVideoObj = this.isVideo(imgDetails.type, imgDetails.subType);
                                if (imgDetails.subType !== "GIPHY") {
                                    if (!imgDetails.src.includes("blob:")) {
                                        let imageId = `${clipKey}-${key}`;
                                        assetArr.push(imageId)
                                    }
                                }
                            }
                        }
                    }
                } else if (itemType === "GRID") {
                    const item = data.scenes[i].workspaceChildren[key];
                    const gridCells = item.gridData && item.gridData.gridCells;
                    if (gridCells) {
                        for (const [cellId, cell] of Object.entries(gridCells)) {
                            const imgDetails = cell.imgDetails;
                            if (imgDetails) {
                                if (imgDetails.subType !== "GIPHY") {
                                    if (!imgDetails.src.includes("blob:")) {
                                        const imageId = `${cellId}-${key}`;
                                        assetArr.push(imageId);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        window.totalArr = assetArr;
        this.props.setAssetArray(assetArr);
    }

    // onUnload = (e) => { 
    //   e.preventDefault();
    //   if(actionCount>0)
    //   {
    //   socket.emit("createversion",3, this.props.userId);
    //   }
    //  }
    handleConnectionChange = (e) => {
        if(e.type==="online" && !this.state.isConnected){
            this.setState({isConnected:true})
        }
        else if(e.type==="offline"){
            this.setState({isConnected:false})
        }
    }
    componentDidMount()
    {
        window.addEventListener('keydown', this.handleKeyDown, false);
        window.addEventListener('keyup', this.handleKeyUp, false);
       // window.addEventListener('beforeunload', this.onUnload,false );
       window.addEventListener('online', this.handleConnectionChange);
       window.addEventListener('offline', this.handleConnectionChange);
        this.startApp();
        this.props.updateUserActive(this.props.userStatus);
       
        var link = document.createElement("link");
        link.id = "NotoSansFallback";
        link.rel = "stylesheet";
        link.href = this.assetUrl+"animaker/admin-fonts/NotoSansFallback.css";;
        document.getElementsByTagName("head")[0].appendChild(link);
    }

    componentWillUnmount()
    {
        socket.disconnect()
        window.removeEventListener('keydown', this.handleKeyDown, false);
        window.removeEventListener('keyup', this.handleKeyUp, false);
        window.removeEventListener('online', this.handleConnectionChange);
      window.removeEventListener('offline', this.handleConnectionChange);
        //window.removeEventListener("beforeunload", this.onUnload,false );
    }
    componentWillReceiveProps(nextProps){
        if( nextProps!==this.props  &&  nextProps.appLoadProgressValue<=100){
            let loadingScreen = document.getElementById('app-start-loading-screen');
            let loader =  document.querySelector(".loaderbar2");
            if(loader){
                loader.style.width= nextProps.appLoadProgressValue+"%";
            }
            if(loadingScreen &&  nextProps.appLoadProgressValue===100){
                loadingScreen.style.display = 'none';
            }
        }
    }

    componentDidUpdate(prevProps, prevState){
        if(prevProps.appLoadProgressValue !== this.props.appLoadProgressValue && this.props.appLoadProgressValue === 100){
            var thumbWidth = this.props.projectWidth > this.props.projectHeight ? 400:this.props.projectWidth < this.props.projectHeight?210:230
            var thumbHeight = this.props.projectWidth > this.props.projectHeight?210:this.props.projectWidth < this.props.projectHeight?400:230;
            saveScreenshot(thumbWidth, thumbHeight).then(function (res) {
                if(res !== null)
                    this.props.saveScreenshot(this.props.selectedScene, "", res[0], this.props.ownerId, this.props.projectid, this.props.sceneId);
            }.bind(this))
        }
       
        if(((prevProps.templateThumbnails.get("status") !== this.props.templateThumbnails.get("status") && this.props.templateThumbnails.get("status") === "started") || (prevProps.templateThumbnails.get("current") !== this.props.templateThumbnails.get("current"))) && this.props.templateThumbnails.get("status") !== "completed"){
         
            this.props.setScene({scene : this.props.templateThumbnails.get("current")});
            var thumbWidth = this.props.projectWidth > this.props.projectHeight ? 352:this.props.projectWidth < this.props.projectHeight?198:200
            var thumbHeight = this.props.projectWidth > this.props.projectHeight?198:this.props.projectWidth < this.props.projectHeight?352:200;
            setTimeout( function(){
                saveScreenshot(thumbWidth, thumbHeight).then(function (res) {
                    try {
                if(res !== null){
                    let url = config["APIURIS"][config["APIURIS"]["current"]] + "app/svest";
                    const params = new URLSearchParams();
                    params.append('userId', this.props.userId);
                    params.append('projectId', this.props.projectid);
                    params.append('project', res[0]);
                    params.append('sceneNo', this.props.templateThumbnails.get("current"));
                    let screenshots = {};
                    params.append('screenshots', JSON.stringify(screenshots));
                    
                    axios({
                        method: 'post',
                        url: url,
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded', "X-CSRFToken": getCookie("csrftoken"), "Authorization" : getCookie("encoded_token") },
                        data: params
                    }).then(function (response) {
                        let current = this.props.templateThumbnails.get("current");
                    
                        if(current < this.props.templateThumbnails.get("totalScenes") - 1){
                            current += 1;
                        }
                        let toUpdate = {thumbnails : this.props.templateThumbnails.setIn(["thumbnails", this.props.templateThumbnails.get("thumbnails").size, "status"], "completed").get("thumbnails"), current : current};
                        if(this.props.templateThumbnails.get("current") === this.props.templateThumbnails.get("totalScenes") - 1){
                            toUpdate.status = "completed";
                            document.getElementById("app-overlay").className = "";
                            document.getElementById("app-overlay").style.display = "none";
                            document.getElementById("app-overlay").style.zIndex = "9";
                            document.getElementById("app-overlay").style.backgroundColor = "transparent";
                            document.getElementById("app-overlay").style.background = "none";
                            this.props.manageToast({action : "add", type : "success", "message" : "sv.su", formatId: "msg"});
                            window.open(config["APIURIS"][config["APIURIS"]["current"]] + 'brand', '_blank');
                        }
                        this.props.updateThumbnails(toUpdate);
                    }.bind(this)).catch(function (error) {
                        document.getElementById("app-overlay").className = "";
                        document.getElementById("app-overlay").style.display = "none";
                        document.getElementById("app-overlay").style.zIndex = "9";
                        document.getElementById("app-overlay").style.backgroundColor = "transparent";
                        document.getElementById("app-overlay").style.background = "none";
                        this.props.manageToast({action : "add", type : "error", "message" : "common.toast.msg", subMessage : "common.toast.submsg", formatId: "both"});
                        this.props.updateThumbnails({thumbnails : fromJS([]), current : 0, status : "failed"});
                    }.bind(this));
                }               
                    } catch (error) {
                        //Error Severity: LOW
                        //Project Screen Shot
                        errorlog("Error in project screenshot", error, "Animaker-saveScreenshot");
                    }
            }.bind(this))}.bind(this), 500)
            
        }
    }

    getRecordTime(time)
    {
        this.setState({ voiceTime: time });
    }

    appLoadingCompleted(e){
        let loadingScreen = document.getElementById('app-start-loading-screen');
        loadingScreen.style.display = 'none';
    }



    handleKeyDown(e)
    {
     try {
         //for the Up and Right arrow   
         if(e.which === 16)
         this.setState({workspace: ""});
         
        if(e.which === 38 || e.which === 39)
        {   
            if(this.props.isPlayAll && this.props.isFullScreen){
            this.props.setPlayerPosition();
            if (this.props.t1.currentLabel() >= this.props.t1.getLabelsArray().length-1) {
                document.getElementById('nextSlide').src = this.appUrl + "/images/playerControls-icons/next-disable.svg";
                document.getElementById('nextSlide').style.cursor = 'auto';
                document.getElementById('next-slide').style.cursor = 'auto';
              }
               if (this.props.t1.currentLabel() !== null) {
                document.getElementById('prevSlide').src = this.appUrl + "/images/playerControls-icons/previous.svg";
                document.getElementById('prevSlide').style.cursor = 'pointer';
                document.getElementById('previous-slide').style.cursor = 'pointer';

              }
            }
            if(this.props.isPreview===true && !this.props.isPlayAll){ 
            let currentScene = this.props.currentSceneNumber;
            if(this.props.scenes.count()>1){
            if(currentScene < this.props.projectData.get('scenes').count()-1) 
            {
                this.props.setScenePosition(this.props.projectData.getIn(['scenes' , currentScene+1 ]),currentScene+1,this.props.projectData.getIn(['scenes',currentScene+1,'startTime']) , this.props.projectData.getIn(['scenes',currentScene+1,'duration']));
                document.getElementById('prevSlide').src = this.appUrl + "/images/playerControls-icons/previous.svg";
                document.getElementById('prevSlide').style.cursor = 'pointer';
                document.getElementById('previous-slide').style.cursor = 'pointer';
            }
            if(currentScene+1 >= this.props.projectData.get('scenes').count()-1){
                document.getElementById('nextSlide').src = this.appUrl + "/images/playerControls-icons/next-disable.svg";
                document.getElementById('nextSlide').style.cursor = 'auto';
                document.getElementById('next-slide').style.cursor = 'auto';
                }
            }
        }   
    }
        // for the Down and Left arrow
        if(e.which === 40 || e.which === 37)
        {
            if(this.props.isPlayAll && this.props.isFullScreen){
            this.props.setPlayerPosition('Prev');
            if (this.props.t1.currentLabel() === null) {
                document.getElementById('prevSlide').src = this.appUrl + "/images/playerControls-icons/previous-disable.svg";
                document.getElementById('prevSlide').style.cursor = 'auto';
                document.getElementById('previous-slide').style.cursor = 'auto';
              }
        if (this.props.t1.currentLabel() < this.props.t1.getLabelsArray().length) {
                document.getElementById('nextSlide').src = this.appUrl + "/images/playerControls-icons/next.svg";
                document.getElementById('nextSlide').style.cursor = 'pointer';
                document.getElementById('next-slide').style.cursor = 'pointer';
        }
        }
        if(this.props.isPreview===true && !this.props.isPlayAll){
        if(this.props.scenes.count()>1){
        if(this.props.currentSceneNumber>0)
        {
          this.props.setScenePosition(this.props.projectData.getIn(['scenes' , this.props.currentSceneNumber-1 ]),this.props.currentSceneNumber-1,this.props.projectData.getIn(['scenes',this.props.currentSceneNumber-1,'startTime']) , this.props.projectData.getIn(['scenes',this.props.currentSceneNumber-1,'duration']));
         }
        if(this.props.currentSceneNumber< this.props.projectData.getIn(['scenes',this.props.currentSceneNumber]).count()){
          document.getElementById('nextSlide').src = this.appUrl + "/images/playerControls-icons/next.svg";
          document.getElementById('nextSlide').style.cursor = 'pointer';
          document.getElementById('next-slide').style.cursor = 'pointer';
        }
        
       if(this.props.currentSceneNumber ===0 || this.props.currentSceneNumber ===null){
        document.getElementById('prevSlide').src = this.appUrl + "/images/playerControls-icons/previous-disable.svg";
        document.getElementById('prevSlide').style.cursor = 'none';
        document.getElementById('previous-slide').style.cursor = 'none';
       }
      }
     } 
        }
    
        this.isRefresh = false;
        if (e.which === 116)
            this.isRefresh = true;
        if (e.keycode === 82)
            this.isRefresh = true;

        let optionArr = validateKeydown(e, this.props.isWorkspaceTextFocus, this.props.textStatus), tempState = {};
        
        for (let i = 0; i < optionArr.length && (((!this.props.isPlay && !this.props.isPlayAll) || optionArr[i].component === "playerControl") && ((!this.props.isWorkspaceTextFocus && !this.props.textStatus.get('isFocused')) || optionArr[i].component === "textProperty"  || (optionArr[i].option === "UNDO_PROJECT" || optionArr[i].option === "REDO_PROJECT")  )); i++)
        {
            let keyoption = optionArr[i].option;
            if (keyoption !== "")
            {
                if (this.state[`${optionArr[i].component}`] === keyoption)
                    keyoption += "_AGAIN";
                tempState[`${optionArr[i].component}`] = keyoption;
            }
        }
      
        if (Object.keys(tempState).length > 0)
            this.setState(tempState);
     } catch (error) {
        errorlog(error, error.message, "App-handleKeyDown")
     }
    }

    handleKeyUp(e)
    {
      try {
        if (this.state.playerControl || this.state.workspace || this.state.slides || this.state.menuBar || this.state.library || this.state.textProperty)
            this.setState({ playerControl: "", workspace: "", slides: "", menuBar: "", library: "", textProperty: "" });
      } catch (error) {
            errorlog(error, error.message, "App-handleKeyUp")
      }
    }

    changeBoxes(whichState, screens = null)
    {

        if (whichState === 'screens')
            this.setState({ worksheet: screens });

        if (whichState === 'screenPressed')
            this.setState({ screenPressed: !this.state.screenPressed });
    }

    handleMouseClick=(e)=>{
    try {
        if(e.target.id !== 'full-screen' && e.target.id !== 'fullScreen' && e.target.id !== 'next-slide'
        && e.target.id !== 'previous-slide' && e.target.id !=='prevSlide' && e.target.id !== 'nextSlide'&&(!e.target.closest('a'))){
            if(this.props.isFullScreen &&  this.props.isPlayAll){
                this.props.setPlayerPosition();
                if (this.props.t1.currentLabel() >= this.props.t1.getLabelsArray().length-1) {
                    document.getElementById('nextSlide').src = this.appUrl + "/images/playerControls-icons/next-disable.svg";
                    document.getElementById('nextSlide').style.cursor = 'auto';
                    document.getElementById('next-slide').style.cursor = 'auto';
                }
                 if (this.props.t1.currentLabel() !== null) {
                    document.getElementById('prevSlide').src = this.appUrl + "/images/playerControls-icons/previous.svg";
                    document.getElementById('prevSlide').style.cursor = 'pointer';
                    document.getElementById('previous-slide').style.cursor = 'pointer';
                }
            } 
        }
    } catch (error) {
        errorlog(error, error.message, "App-handleMouseClick")
    }
    }

    redirectPayment=()=>{
       try{
           const {teamId,manageToast,setPaymentPastDue,setWorkspaceTextFocus} = this.props;
       }
       catch(err){
        errorlog(err, err.message, "App-PaymentDueFailed")
       }
    }

    render()
    {   
        var projectToLoad = '';
        if(this.state.loaded && this.props.userDetails.size){
            
         
                var toastNotifications = null;
                if(this.props.toastNotifications.size > 0){
                    var toastArray = [];
                    this.props.toastNotifications.map(function(noty, index){
                        toastArray.push(<Toast key = {noty.get("id")} data = {noty} manageToast = {this.props.manageToast}/>);
                    }.bind(this));

                    toastNotifications = <div className="toast-notification-controller toast-tool-bar">{toastArray}</div>;
                }
                projectToLoad = <div className={"app full" + (parseInt(this.props.userStatus) === 0?" anonymous":"")} 
                onDragEnter={(e) => {
                    if(e.target.closest('.effects-ul')||e.target.closest('.workspace-main-page')||e.target.closest('.animate-properties'))return;

                    e.preventDefault();
                    e.stopPropagation();
                    
                    let uploadTab = document.querySelector('.icon-UPLOADS');
                    if(uploadTab){
                      uploadTab.click();
                    }
                    let appLIb = document.querySelector('.app-lib-container');
                    if(!appLIb.classList.contains('opened')){
                      document.querySelector('.lib-additional-div').click();
                    }
                }} onDragLeave={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }} onDragOver={e => {
                    e.preventDefault();
                    e.stopPropagation();
                }} onDrop={e => {
                    if((e.target.closest('.lib-showBlock') && e.target.closest('.lib-showBlock').querySelector('.library-pack.uploads'))) return;
                    e.preventDefault();
                   
                    let file = e.dataTransfer.files[0];
                    this.props.draggedFile(file);
                }} style={{backgroundColor:(this.props.isFullScreen||this.props.mode==='slide')?'black':''}}>
              {!this.state.isConnected && !this.props.isFullScreen? <div className="disconnected-wrapper tool-bar">
                    <div className="disconnected-inner">
                        <div className="disconnected-text-bg"></div>
                        <div className="disconnected-text">
                            <span className="v2" tabindex="0" role="link" ><FormattedMessage id="ne.err"></FormattedMessage></span>
                        </div>
                    </div>
                    <div className="disconnect-wrapper"></div>
                </div> : null}
               {this.state.errorThrown && !this.props.isFullScreen ? <div className="disconnected-wrapper tool-bar">
                    <div className="disconnected-inner">
                        <div className="disconnected-text-bg"></div> 
                        <div className="disconnected-text">
                            <span className="v2" tabindex="0" role="link" ><FormattedMessage id="pl.re"></FormattedMessage> </span><span onClick={() =>{ window.location.reload(); }} style={{cursor:"pointer"}}><u><FormattedMessage id="pa.re"></FormattedMessage></u></span>
                        </div>
                    </div>
                    <div className="disconnect-wrapper"></div>
                </div> : null}
                {this.state.authError && !this.props.isFullScreen ? <div className="disconnected-wrapper tool-bar">
                    <div className="disconnected-inner">
                        <div className="disconnected-text-bg"></div> 
                        <div className="disconnected-text">
                        <span className="v2" tabindex="0" role="link" ><FormattedMessage id="auth.err"></FormattedMessage> </span><span onClick={() =>{ window.location.reload();}} style={{cursor:"pointer"}}><u><FormattedMessage id="auth.log"></FormattedMessage></u></span>
                        </div>
                    </div>
                    <div className="disconnect-wrapper"></div>
                </div> : null}
                {this.state.sesError ? <div className="disconnected-wrapper tool-bar">
                <div className="disconnected-inner">
                <div className="disconnected-text-bg"></div>
                <div className="disconnected-text">
                <span className="v2" tabindex="0" role="link" ><FormattedMessage id="ses.err"></FormattedMessage> </span><span onClick={() => { window.location.reload(); }} style={{ cursor: "pointer" }}><u><FormattedMessage id="ses.log"></FormattedMessage></u></span>
                </div>
                </div>
                <div className="disconnect-wrapper"></div>
                </div> : null}
                {this.props.isProjectRestore && !this.props.isFullScreen ? <div className="disconnected-wrapper tool-bar">
                    <div className="disconnected-inner">
                        <div className="disconnected-text-bg"></div> 
                        <div className="disconnected-text">
                            <span className="v2" tabindex="0" role="link" ><FormattedMessage id="res.pro"></FormattedMessage> </span>
                        </div>
                    </div>
                    <div className="disconnect-wrapper"></div>
                </div> : null}

                {this.state.isRestored && !this.props.isFullScreen ? <div className="disconnected-wrapper tool-bar">
                    <div className="disconnected-inner">
                        <div className="disconnected-text-bg"></div> 
                        <div className="disconnected-text">
                            <span className="v2" tabindex="0" role="link" >
                                { this.state.restoreUser === null ?<FormattedMessage id="res.pro.suc"></FormattedMessage> :
                               <div> <span> <FormattedMessage id="res.pro.by"> </FormattedMessage> {this.state.restoreUser} </span> <span onClick={() =>{ window.location.reload(); }} style={{cursor:"pointer"}}><u><FormattedMessage id="pa.re"></FormattedMessage></u></span> </div>
                                }
                                </span>
                        </div>
                    </div>
                    <div className="disconnect-wrapper"></div>
                </div> : null}
                 
                {this.state.isRestoring && !this.props.isFullScreen ? <div className="disconnected-wrapper tool-bar">
                    <div className="disconnected-inner">
                        <div className="disconnected-text-bg"></div> 
                        <div className="disconnected-text">
                            <span className="v2" tabindex="0" role="link" >{this.state.restoreUser} <FormattedMessage id="res.pro"></FormattedMessage> </span>
                        </div>
                    </div>
                    <div className="disconnect-wrapper"></div>
                </div> : null}
                {this.state.restoreCheck && !this.props.isFullScreen ? <div className="disconnected-wrapper tool-bar">
                    <div className="disconnected-inner">
                        <div className="disconnected-text-bg"></div> 
                        <div className="disconnected-text">
                            <span className="v2" tabindex="0" role="link" > <FormattedMessage id="oth.res"></FormattedMessage> </span>
                        </div>
                    </div>
                    <div className="disconnect-wrapper"></div>
                </div> : null}
                
                <div className="app-main-page">
                    <div className="app-page">
                      {/* {(this.props.isFullScreen ===true||this.props.mode==='slide')? "": <ErrorHandler component="Library"><Library socket={socket} appType={this.props.appType} projectId={this.props.projectid} userId={this.props.userId} teamId = {this.props.teamId} manageToast = {this.props.manageToast} shortcutName={this.state.library}  langToLoad={this.props.langToLoad}/></ErrorHandler>} */}
                    </div>
                </div>

                {/* {(this.props.isFullScreen ===true||this.props.mode==='slide')? "":  <div data-html2canvas-ignore="true" className="app-menu menu-tool-bar" style = {{zIndex : this.props.anymsUploadStatus === "processing" || this.props.anymsUploadStatus === "failed"? 39 : ""}}>
                <ErrorHandler component="MenuBar">
                        <MenuBar shortcutName={this.state.menuBar} appType={this.props.appType} socket={socket} projectid={this.props.projectid} userId = {this.props.userId} teamId = {this.props.teamId} defaultView = {this.props.defaultView} userStatus = {this.props.userStatus}   langToLoad={this.props.langToLoad}/>
                    </ErrorHandler>
                </div>}
                */}
                {/* {(this.props.isFullScreen ===true||this.props.mode==='slide')? "":<ErrorHandler component="Slides"><Slides shortcutName={this.state.slides} projectId = {this.props.projectid} userId = {this.props.userId} socket={socket}  isUserActive = {this.props.userStatus === undefined || parseInt(this.props.userStatus) === 1}/></ErrorHandler>} */}
                <div className="workspace-main-page" onClick={(e)=>this.handleMouseClick(e)} style={{height:this.props.isFullScreen?'105vh':'100vh'}}> 
                        <React.Fragment>
                            <Workspace socket={socket} userId = {this.props.userId} projectId={this.props.projectid} mode={this.props.mode} shortcutName={this.state.workspace} appState={this.state} animakerType={this.props.animakerType}  teamId={this.props.teamId}  langToLoad = {this.props.langToLoad} />
                        </React.Fragment>
                    {toastNotifications}
                </div>
                {/* {(this.props.isFullScreen ===true||this.props.mode==='slide')? "": <ErrorHandler component="PropertyWindow"><PropertyWindow socket={socket} manageToast={this.props.manageToast} shortcutName={this.state.textProperty} userId = {this.props.userId}  projectId = {this.props.projectid} teamId={this.props.teamId}/></ErrorHandler>} */}
                
                <div id="app-overlay" data-html2canvas-ignore="true" style={{ top: 0, left: 0, right: 0, bottom: 0, position: "absolute", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9, display: "none" }}></div>
                <div id="overlays" data-html2canvas-ignore="true">
                    <div className="snap-line vertical-line ver-left"></div>
                    <div className="snap-line vertical-line ver-center"></div>
                    <div className="snap-line vertical-line ver-right"></div>
                    <div className="snap-line horizontal-line hor-top"></div>
                    <div className="snap-line horizontal-line hor-center"></div>
                    <div className="snap-line horizontal-line hor-bottom"></div>
                    <div className="snap-line rotationLine" ></div>
                    <div className="snap-line rotationDisplay" ><span id="rotationAngle"></span></div>
                </div>
                <div id="highlighter" style={{position : "absolute", boxShadow : "0px 0px 0px 1px #ffc423", zIndex : 15, display : "none", pointerEvents : "none"}}></div>
                {this.props.confirmPopup.get("show")?<ConfirmPopup details = {this.props.confirmPopup}/>:null}
                <CommonPopup socket={socket} userId = {this.props.userId} teamId = {this.props.teamId} projectid = {this.props.projectid}/>
                <ToolTip socket={socket} />
               
            </div>

            
        }
        return (<React.Fragment>
            <IntlProvider locale={this.props.langToLoad} messages={this.state.appLangData.language}>
                <div>  {projectToLoad} </div>
            </IntlProvider>
        </React.Fragment>);
    }
}




const mapStateToProps = (state, ownProps) => ({
    projectData : state.project,
    currentSceneNumber : state.localStore.get('currentSceneNumber'),
    isWorkspaceTextFocus:   state.localStore.get("isWorkspaceTextFocus"),
    textStatus          :   state.localStore.get("textStatus"),
    isPlay              :   state.localStore.get("isPlay"),
    isPlayAll           :   state.localStore.get("isPlayAll"),
    animakerType        :   state.localStore.get("animakerType"),
    showSlidePanel      :   state.localStore.get('showSlidePanel'),
    selectedItems      :   state.localStore.get('selectedItems'),
    selectedScene      :   state.localStore.get('selectedScene'),
    toastNotifications  :   state.localStore.get('toastNotifications'),
    confirmPopup    : state.localStore.get('confirmPopup'),
    appLoadProgressValue              : state.localStore.get('appLoadProgressValue'),
  
    isSuggestionOn : state.localStore.get('isSuggestionOn'),
    showSuggestion : state.localStore.get('suggestionPopup'),
    anymsUploadStatus : state.localStore.get('anymsUploadStatus'),
    invalidBg  : state.project.getIn(["scenes", 0, "workspaceBG", "src"]) === "" || state.project.getIn(["scenes", 0, "workspaceBG", "isBlob"]) === true,
    sceneId  : state.project.getIn(["scenes", state.localStore.get('selectedScene'), "id"]),
    ownerId  : state.localStore.getIn(["userDetails", "owner"]),
    projectWidth  : state.project.get("width"),
    projectHeight : state.project.get("height"),
    templateThumbnails : state.localStore.get("templateThumbnails"),
    userDetails : state.localStore.get('userDetails'),
    isFullScreen : state.localStore.get('isFullScreen'),
    isNewAction : state.localStore.get('isNewAction'),
    t1 : state.localStore.get('t1'),
    isPreview : state.localStore.get('isPreview'),
    scenes    : state.project.getIn(["scenes"]),
    isProjectRestore : state.localStore.get('isProjectRestore'),
    versionId : state.localStore.get('versionId'),
    propertyWindow : state.localStore.get('propertyWindow')

})


const mapDispatchToProps = (dispatch, ownProps) => ({
    appLoadProgess: (data) => { dispatch({
        type : 'APP_LOAD_PROGRESS',
        data
    })},
    loadProject: (projectid, projectUsr,mode,userId,projectUsrImg,socketid) => { dispatch({ type: "LOAD_PROJECT", projectid, projectUsr,mode,userId,projectUsrImg,socketid}) },
    loadUserFonts: (projectid, userId, socketid) => { dispatch({ type: "LOAD_USER_FONTS", projectid, userId, socketid}) },
    setUserDetails: (data) => {dispatch({type : "SET_USER_DETAILS", data : data})},
    loadSceneThumbs: (data) => { dispatch({ type: "LOAD_SCENE_THUMBS", data : data}) },
    addSceneComplete: (slideIndex, newslide, socketId, currentSocketId) => { dispatch(addSceneComplete(slideIndex, newslide, socketId, currentSocketId)) },
    duplicateSceneComplete: (slideIndex, newslide, socketId, currentSocketId) => { dispatch(duplicateSceneComplete(slideIndex, newslide, socketId, currentSocketId)) },
    removeSceneComplete: (slideIndex, socketId, currentSocketId) => { dispatch(removeSceneComplete(slideIndex,socketId, currentSocketId)) },
    addSceneTransitionComplete: (slideIndex, transitionName, sizes, socketId, currentSocketId) => { dispatch(addSceneTransitionComplete(slideIndex, transitionName, sizes, socketId, currentSocketId)) },
    changeSceneTransColorComplete: (selectedScene, color, socketId, currentSocketId) => { dispatch(changeSceneTransColorComplete(selectedScene, color, socketId, currentSocketId)) },
    changeExpressionComplete: (selectedIndex, itemId, itemLabel, socketId, currentSocketId) => { dispatch(changeExpressionComplete(selectedIndex, itemId, itemLabel, socketId, currentSocketId)) },
    changeActionComplete: (selectedIndex, itemId, itemLabel, socketId, currentSocketId) => { dispatch(changeActionComplete(selectedIndex, itemId, itemLabel, socketId, currentSocketId)) },
    deleteBgComplete: (selectedScene, socketId, currentSocketId) => { dispatch(deleteBgComplete(selectedScene, socketId, currentSocketId)) },
    addObjComplete: (selectedScene, workspaceIds, workspaceData, workspaceChildrenIds, workspaceChildData, socketId, currentSocketId) => { dispatch(addObjComplete(selectedScene, workspaceIds, workspaceData, workspaceChildrenIds, workspaceChildData, socketId, currentSocketId)) },
    changeBgComplete: (selectedScene, workspaceBG, deleteId, deleteData, socketId, currentSocketId) => { dispatch(changeBgComplete(selectedScene, workspaceBG, deleteId, deleteData,socketId, currentSocketId)) },
    moveUpdateComplete: (selectedScene, workspaceItems, workspaceChildren, currentContainer,socketId, currentSocketId) => { dispatch(moveUpdateComplete(selectedScene, workspaceItems, workspaceChildren, currentContainer,socketId, currentSocketId)) },
    changeVideoVolumeComplete: (selectedScene, objectId, objectData, socketId, currentSocketId) => { dispatch(changeVideoVolumeComplete(selectedScene, objectId, socketId, currentSocketId)) },
    applyFilterComplete: (selectedScene, objectId, objectData, socketId, currentSocketId) => { dispatch(applyFilterComplete(selectedScene, objectId, objectData, socketId, currentSocketId)) },
    updateSvgColorComplete: (selectedScene, container, itemId, itemCls, colorData, socketId, currentSocketId) => { dispatch(updateSvgColorComplete(selectedScene, container, itemId, itemCls, colorData, socketId, currentSocketId)) },
    updateSvgThemeComplete: (projectid, selectedScene, container, itemId, colorData, isBG, socketId, currentSocketId) => { dispatch(updateSvgThemeComplete(projectid, selectedScene, container, itemId, colorData, isBG, socketId, currentSocketId)) },
    cropImageComplete: (selectedScene, itemId, objectData, socketId, currentSocketId) => { dispatch(cropImageComplete(selectedScene, itemId, objectData, socketId, currentSocketId)) },
    flipItemComplete: (selectedScene, itemId, flipPosition, socketId, currentSocketId) => { dispatch(flipItemComplete(selectedScene, itemId, flipPosition, socketId, currentSocketId)) },
    cropBgComplete: (selectedScene, objectData, isVideo, videoId, bgScales, socketId, currentSocketId) => { dispatch(cropBgComplete(selectedScene, objectData, isVideo, videoId, bgScales, socketId, currentSocketId)) },
    bgColorSelectionComplete: (selectedScene, objectData, socketId, currentSocketId) => { dispatch(bgColorSelectionComplete(selectedScene, objectData, socketId, currentSocketId)) },
    bgGradientColorsComplete: (selectedScene, radialStatus, direction, radius, socketId, currentSocketId) => { dispatch(bgGradientColorsComplete(selectedScene, radialStatus, direction, radius, socketId, currentSocketId)) },
    changeTextComplete: (selectedScene, currentContainer, itemId, objectData, socketId, currentSocketId) => { dispatch(changeTextComplete(selectedScene, currentContainer, itemId, objectData, socketId, currentSocketId)) },
    groupObjectsComplete: (selectedScene, removeIds, workspaceItems, workspaceChildren, workspaceItemsOrder,socketId, currentSocketId) => { dispatch(groupObjectsComplete(selectedScene, removeIds, workspaceItems, workspaceChildren, workspaceItemsOrder,socketId, currentSocketId)) },
    ungroupObjectsComplete: (selectedScene, removeIds, workspaceChildren,workspaceItemsOrder, socketId, currentSocketId) => { dispatch(ungroupObjectsComplete(selectedScene, removeIds, workspaceChildren, workspaceItemsOrder,socketId, currentSocketId)) },
    deleteItemComplete: (selectedScene, workspaceIds, workspaceChildrenIds, indexChangeIds, socketId, currentSocketId) => { dispatch(deleteItemComplete(selectedScene, workspaceIds, workspaceChildrenIds, indexChangeIds, socketId, currentSocketId)) },
    setZIndexComplete: (selectedScene, indexChangeIds, socketId, currentSocketId) => { dispatch(setZIndexComplete(selectedScene, indexChangeIds, socketId, currentSocketId)) },
    updateTimelineDragChangeComplete: (selectedScene, itemData, actionData, idVal, childToUpdate, socketId, currentSocketId) => { dispatch(updateTimelineDragChangeComplete(selectedScene, itemData, actionData, idVal, childToUpdate, socketId, currentSocketId)) },
    pasteItemsComplete: (selectedScene, workspaceIds, workspaceChildrenIds, workspaceData, workspaceChildData, socketId, currentSocketId) => { dispatch(pasteItemsComplete(selectedScene, workspaceIds, workspaceChildrenIds, workspaceData, workspaceChildData, socketId, currentSocketId)) },
    updateTextComplete: (selectedScene, isGrouped, selectedId, container, formats, childIds, socketId, currentSocketId) => { dispatch(updateTextComplete(selectedScene, isGrouped, selectedId, container, formats, childIds, socketId, currentSocketId)) },
    updateGroupTextComplete: (selectedScene, workspaceItems, workspaceChildren, socketId, currentSocketId) => { dispatch(updateGroupTextComplete(selectedScene, workspaceItems, workspaceChildren, socketId, currentSocketId)) },
    pasteScenesComplete: (selectedScene, scenes, socketId, currentSocketId) => { dispatch(pasteScenesComplete(selectedScene, scenes, socketId, currentSocketId)) },
    setSelectedItemsComplete: (projectid, selectedItems, projectUsr,userId,projectUsrImg, socketid, currentSocketId) => { dispatch(setSelectedItemsComplete(projectid, selectedItems, projectUsr,userId,projectUsrImg,socketid, currentSocketId)) },
    setSelectedSceneComplete: (projectid, selectedItems, projectUsr,userId,projectUsrImg,socketid, currentSocketId) => { dispatch(setSelectedSceneComplete(projectid, selectedItems, projectUsr,userId,projectUsrImg, socketid, currentSocketId)) },
    updateBgColorComplete: (selectedScene,Cls, color, socketid, currentSocketId) => { dispatch(updateBgColorComplete(selectedScene,Cls, color, socketid, currentSocketId)) },
    updateBgGradientComplete: (selectedScene, gradientIndex, gradientSecIndex, color, socketid, currentSocketId) => { dispatch(updateBgGradientComplete(selectedScene, gradientIndex, gradientSecIndex, color, socketid, currentSocketId)) },
    socketConnected: (projectid, userId, selectedItems, imageUrl, projectUsr, socketid, currentSocketId) => { dispatch(socketConnected(projectid, userId, selectedItems, imageUrl, projectUsr, socketid, currentSocketId)) },
    changeAnimationTypeComplete: (selectedScene, itemId, value, socketId, currentSocketId) => { dispatch(changeAnimationTypeComplete(selectedScene, itemId, value, socketId, currentSocketId)) },
    moveSceneComplete: (projectid, newIndex, oldIndex, socketId, currentSocketId) => { dispatch(moveSceneComplete(projectid, newIndex, oldIndex, socketId, currentSocketId)) },
    updateSceneComplete: (projectid, selectedScene, toUpdate, toEmit, socketId, currentSocketId) => { dispatch(updateSceneComplete(projectid, selectedScene, toUpdate, toEmit, socketId, currentSocketId)) },
    updateBgComplete: (projectid, selectedScene, toUpdate, socketId, currentSocketId) => { dispatch(updateBgComplete(projectid, selectedScene, toUpdate, socketId, currentSocketId)) },
    updateProjectComplete: (projectid, toUpdate, socketId, currentSocketId) => { dispatch(updateProjectComplete(projectid, toUpdate, socketId, currentSocketId)) },
    updateObjectComplete: (projectid, selectedScene, selectedItem, container, toUpdate, socketId, currentSocketId) => { dispatch(updateObjectComplete(projectid, selectedScene, selectedItem, container, toUpdate, socketId, currentSocketId)) },
    addPrebuiltComplete: (selectedScene, prebuiltData, replace, addAll, socketId, currentSocketId) => { dispatch(addPrebuiltComplete(selectedScene, prebuiltData, replace, addAll, socketId, currentSocketId)) },
    newSocketConnected: (data) => { dispatch(newSocketConnected(data)) },
    socketDisconnected: (socketId) => { dispatch(socketDisconnected(socketId)) },
    manageToast:(data) => {dispatch(manageToast(data))},
    initiateProject: (data) => {dispatch({
        type : 'INITIATE_PROJECT',
        data
    })},
   
    setFullTab: () => {dispatch(setFullTab())},
    uploadedFile: (data) => {dispatch(uploadedFile(data))},
    openCommonPopup: (value, status)    =>{ 
        dispatch(loadCommonPopup(value, status))
    },
    dropBG: (data, deleteData,socket) => {
        dispatch(dropBG(data, deleteData,socket))
    },
    updateUserActive: (data) => {dispatch(updateUserActive(data))},
    updateBg : (data, socket) => {dispatch({type : 'UPDATE_BG', data, socket})},
    draggedFile : (data) => {dispatch(draggedFile(data))},
    saveScreenshot: (index, scene, project, userId, projectId, sceneId, isExceeded, screenshots) => {
        dispatch({type : "SAVE_SCREENSHOT", index, scene, project, userId, projectId, sceneId, isExceeded, screenshots})
    },
    updateThumbnails: (data) => {
        dispatch({type : 'UPDATE_THUMBNAILS', data})
    },
    setScene : (data) => {
        dispatch({type : "SET_SCENE", data : data})
    },
    updateUserDetails : (data) => {dispatch(updateUserDetails(data))},
    applyEnterEffectComplete :(projectid,selectedScene,effectData,isUndo,sceneEffectData,socketId, currentSocketId) => { dispatch(applyEnterEffectComplete(projectid,selectedScene,effectData,isUndo,sceneEffectData,socketId, currentSocketId)) },
    applyAllTransitionComplete :(projectid, transData,isUndo , seceneTransData,  socketId, currentSocketId) => { dispatch(applyAllTransitionComplete(projectid, transData,isUndo, seceneTransData, socketId, currentSocketId)) },
    addLinkToTextComplete : (projectid, selectedScene, container,selectedItem, hyperLinkData, socketId ,currentSocketId)=>{dispatch (addLinkToTextComplete(projectid, selectedScene, container,selectedItem, hyperLinkData, socketId,currentSocketId))},
    addLinkToObjComplete : (projectid, selectedScene,selectedItem,linkData, socketId ,currentSocketId)=>{dispatch (addLinkToObjComplete(projectid, selectedScene,selectedItem,linkData, socketId,currentSocketId))},
    setPlayerPosition:(data) => { dispatch(setPlayerPosition(data)) },
    setScenePosition : (data  , currentSceneNumber , currentSceneStartTime , currentSceneDuration) =>
     dispatch(setScenePosition(data  , currentSceneNumber , currentSceneStartTime , currentSceneDuration)),
     setWorkspaceItemsOrderComplete: (projectId,selectedScene,container,workspaceItem,socketId,currentSocketId)=>{dispatch (setWorkspaceItemsOrderComplete(projectId,selectedScene,container,workspaceItem,socketId,currentSocketId))},
    setAnimateValueComplete :(projectid,selectedScene,container,selectedItem,animateData,socketId,currentSocketId) => {dispatch(setAnimateValueComplete(projectid,selectedScene,container,selectedItem,animateData,socketId,currentSocketId))},
    setNewActionComplete:(data)=>{dispatch(setNewActionComplete(data))},
    projectRestore :(data,socket) =>{dispatch(projectRestore(data,socket))},
    setPropertyWindow  : (data) => {dispatch(setPropertyWindow(data))},
    addVersionHistory :(data) => {dispatch({type:'VERSION_HISTORY',data})},
    setPaymentPastDue:(data,socket)=>{dispatch(setPaymentPastDue(data,socket))},
    setWorkspaceTextFocus:(data) => {
        dispatch(setWorkspaceTextFocus(data))
    },
    setAssetArray: (data) => { dispatch({ type: 'SET_ASSET_ARRAY', data }) },

})



export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/components/App.js